import reduceReducers from "reduce-reducers";

import { BUSINESS_RELATIONS } from "constants/actionTypes";

import {
  apiModelOfflineCreateReducer,
  apiModelOfflineDeleteReducer,
  apiModelOfflineFetchReducer,
  apiModelOfflineUpdateReducer,
} from "lib/reducers";
import { deserializeBusinessRelation } from "lib/serializers/businessRelations";

const create = apiModelOfflineCreateReducer(BUSINESS_RELATIONS, {
  deserializer: deserializeBusinessRelation,
});

const fetch = apiModelOfflineFetchReducer(BUSINESS_RELATIONS, {
  deserializer: deserializeBusinessRelation,
  clearOnRequest: true,
});

const update = apiModelOfflineUpdateReducer(BUSINESS_RELATIONS, {
  deserializer: deserializeBusinessRelation,
});

const deleteReducer = apiModelOfflineDeleteReducer(BUSINESS_RELATIONS);

const businessRelationReducer = reduceReducers(
  create,
  fetch,
  update,
  deleteReducer,
);

export default businessRelationReducer;
